export function uuidV7ToMs(uuid) {
    const hex = uuid.replace(/-/g, '').slice(0, 12);
    return parseInt(hex, 16);
}
